import {
    PARAMETERS,
    THEME,
    MAINCOLOR
  } from "./actionTypes"
  
  const initialState = {
    appName: 'Web App',
    logo: '',
    logoDark: '',
    logoIcon: '',
    logoIconDark: '',
    theme: 'light',
    mainColor: 'blue'
  }
  
  const Parameters = (state = initialState, action) => {
    switch (action.type) {
        case PARAMETERS:
            return {
                ...state,
                appName: action.payload.appName,
                logo: action.payload.logo,
                logoDark: action.payload.logoDark,
                logoIcon: action.payload.logoIcon,
                logoIconDark: action.payload.logoIconDark
            }
        case THEME: 
          return {
            ...state,
            theme: action.payload.theme,
          }
        case MAINCOLOR: 
          return {
            ...state,
            mainColor: action.payload.mainColor
          }
        default:
          return state;
    }
  }
  
  export default Parameters;
  